import { useState } from "react";

// components
import { AddItem } from "./add-item";
import { DeleteBox } from "./delete-box";
import { AddFeedback } from "./add-feedback";
import { EditReturnDate } from "./edit-return-date";
import { SetNotPickedUp } from "./set-not-picked-up";
import { ItemFigure } from "../common/item-figure";

// components
import { Box, BoxHeader } from "../common/box";

const BoxItem = (props) => (
    <ItemFigure edit={true} withStatus={true} {...props} />
);

const EditBox = ({ customer, box, number, withStatus }) => {
    const [boxData, setBoxData] = useState(box);
    const [deleted, setDeleted] = useState(false);

    const handleChange = () => {
        setBoxData({ ...boxData });
    }

    const handleFeedbackChange = (extra_feedback) => {
        setBoxData({ ...boxData, extra_feedback });
    }

    const handleEditDate = (returnDate) => {
        setBoxData({ ...boxData, return_date: returnDate, status: "at_customer" });
    }

    const handleDelete = () => {
        setDeleted(true);
    }
    const handleNotPickedUp = () => {
        setBoxData({ ...boxData, status: 'not_picked_up', feedbackSaved: true });
    }

    const Header = () => {
        return (
            <BoxHeader customer={customer} box={boxData} number={number} withStatus={withStatus}>
                <div className="buttons">
                    <AddItem customer={customer} box={boxData} onAdd={handleChange} />
                    <AddFeedback customer={customer} box={boxData} onAdd={handleFeedbackChange} />
                    <EditReturnDate customer={customer} box={boxData}
                        onEdit={handleEditDate}
                    />
                    <DeleteBox customer={customer} box={boxData} onClick={handleDelete} />
                    <SetNotPickedUp customer={customer} box={boxData} onClick={handleNotPickedUp} />
                </div>
            </BoxHeader>
        )
    };

    if (deleted) {
        return (
            <article className="message is-success p-6">
                <div className="message-body">
                    This <span className="tooltip-has-arrow" data-tooltip={box.id}>box</span> has been deleted.
                </div>
            </article>
        );
    }

    return (
        <Box customer={customer} box={boxData}
            HeaderComponent={Header} ContentComponent={BoxItem} withStatus={withStatus} />
    );
}

export { EditBox };
